import { z } from 'zod';
import type { TaxonomyChangedPart } from '@inference.engine/taxonomy/web';

const cellValue = z.union([z.string(), z.array(z.string()), z.null()]).optional();

/** What the taxonomy agent streams after a write, parsed at the stream's edge. */
export const taxonomyChangedSchema = z.object({
  datasetId: z.string(),
  records: z
    .array(
      z.object({
        id: z.string(),
        cells: z.record(z.string(), cellValue),
        assembledName: z.string().nullable(),
        outputs: z.record(z.string(), z.string()),
        revision: z.number(),
        sortKey: z.number().optional(),
      }),
    )
    .optional(),
  removedIds: z.array(z.string()).optional(),
  dataset: z
    .object({
      name: z.string().optional(),
      campaignId: z.string().nullable().optional(),
      taxonomyVersionId: z.string().optional(),
    })
    .optional(),
  schemaChanged: z.boolean().optional(),
}) satisfies z.ZodType<TaxonomyChangedPart>;
